import React, { useState, useEffect } from 'react';
import update from 'immutability-helper';
import MaterialTable from 'material-table'
import PatchedPagination from './PatchedPagination';
import Dropzone from './dropzone';
import { tableIcons } from '../commonTypes';
import { useTableTheming } from './useTableTheming';


const columnsByMode = editMode => {

    return editMode ? [
        { title: 'Name', field: 'name', editable: 'never' },
        { title: 'Description', field: 'description' },
        { title: 'Type', field: 'type', editable: 'never' }
    ] :
        [
            { title: 'Name', field: 'name' },
            { title: 'Description', field: 'description' },
            { title: 'Type', field: 'type' }
        ]
}

let showDragDrop = false;

/**
 * @param  {} props
 * admin - open in admin mode
 */
export default function SensorTable(props) {

    const [sensors, setSensors] = useState(props.sensors);
    const [selectedRow, setSelectedRow] = useState(null);
    const tableTheme = useTableTheming(selectedRow);
    const [sensorsUpdated, setSensorsUpdated] = useState(false);
   // const showDragDrop = useRef();

    const actions = [];
    if (props.admin) {

        actions.push({
            icon: tableIcons.AddIcon,
            tooltip: 'Add Sensor',
            isFreeAction: true,
            onClick: (event, data) => {
                setSensors(update(sensors, {
                    $push: [{
                        name: 'EO',
                        description: 'Sensor',
                        type: 'video',
                        files: []
                    }]
                }));
            }
        });

        actions.push({
            icon: tableIcons.DeleteIcon,
            tooltip: 'Delete Sensor(s)',
            isFreeAction: true,
            onClick: event => {
                if (selectedRow) {
                    setSensors(update(sensors, { $splice: [[selectedRow.tableData.id, 1]] }));
                    setSensorsUpdated(true);
                }
            }
        })
    }

    /**
     * Open Drag & drop with some delay 
     */
    useEffect(() => {  
        if(!showDragDrop) {
            setTimeout(()=>{
                const openBtn = document.getElementById('open-btn-id');
                if (openBtn) {
                    openBtn.click();
                }
            }, 500); 
            showDragDrop = true;
        }            
    }, []);



    useEffect(() => {
        if (sensorsUpdated && props.onChange) {
            props.onChange(sensors);
            setSensorsUpdated(false);
        }
    }, [sensorsUpdated]);


    const handleFileDrop = sensor => {

        const index = sensors.findIndex(s => s.name === sensor.name);
        setSensors(update(sensors, { [index]: { $set: sensor } }));
        setSensorsUpdated(true);
    }

    return (
        <React.Fragment>
            <MaterialTable
                icons={tableIcons}
                columns={columnsByMode(props.editMode)}
                data={sensors}
                title="Sensors"
                actions={actions}
                onRowClick={((evt, selectedRow, togglePanel) => {
                    setSelectedRow(selectedRow);
                    togglePanel()
                }
                )}
                editable={{
                    //TODO:
                    // Currently, only enable add button in Create mission mode, not edit. Add functionality here.
                    // onRowAdd: !props.editMode ? newData =>
                    //     new Promise((resolve, reject) => {
                    //         setSensors(update(sensors, { $push: [newData] }));
                    //         resolve();
                    //         setSensorsUpdated(true);
                    //     }) : undefined,
                    onRowUpdate: (newData, oldData) =>
                        new Promise((resolve, reject) => {
                            const index = sensors.indexOf(oldData);
                            setSensors(update(sensors, { [index]: { $set: newData } }));
                            resolve();
                            setSensorsUpdated(true);
                        })
                }}
                detailPanel={[
                    {
                        tooltip: 'Select files to upload',
                        icon: tableIcons.CloudUploadOutlinedIcon,
                        render: rowData => {
                            return (
                                <Dropzone sensor={rowData} editMode={props.editMode} onFileDrop={handleFileDrop} />
                            )
                        }
                    }
                ]}
                options={{
                    cellStyle: tableTheme.cellStyle,
                    headerStyle: tableTheme.headerStyle,
                    filterRowStyle: tableTheme.filterRowStyle,
                    // actionsColumnIndex: -1,                       
                    rowStyle: tableTheme.rowStyle
                }}
                components={{
                    Pagination: PatchedPagination,
                }}

            />
        </React.Fragment>
    );
}
